export default __webpack_public_path__ + "static/media/review-icon-1.376043c9.svg";